import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipe } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";
import { IRecipeFormFields } from "../../sdk/utils/api/recipes";

export const useCreateRecipe = (): UseMutationResult<
    IRecipe,
    unknown,
    IRecipeFormFields
> => {
    const auth = useAuth();

    return useMutation<IRecipe, unknown, IRecipeFormFields>({
        mutationFn: (parameters: IRecipeFormFields) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create recipe without authorization token.",
                );
            }

            return recipes.Recipe.create({ ...parameters, token: auth.token });
        },
    });
};
